import React from "react";
import { Col, Row } from "react-bootstrap";

const PersonalInfo = ({ data }) => {
  return (
    <div>
      <section className="view-data">
        <Row className="main-view-email pt-3">
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Full Name:</strong>
              {data?.full_name || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Marital Status:</strong>
              {data?.marital_status || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Address:</strong>
              {data?.address || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Cell Phone:</strong>
              {(data?.cell_phone && "+" + data?.cell_phone) || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Work Phone:</strong>
              {(data?.work_phone && "+" + data?.work_phone) || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Home Phone:</strong>
              {(data?.home_phone && "+" + data?.home_phone) || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Email:</strong>
              {data?.email || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Fax:</strong>
              {data?.fax || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Social Security No (SSN):</strong>
              {data?.social_security_no || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">DOB:</strong>
              {data?.date_of_birth || "--"}
            </div>
          </Col>
          <Col md={12} className="left-name-data">
            <h5 className="mb-3">Dependents:</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Name:</strong>
              {data?.dependents?.name || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Age:</strong>
              {data?.dependents?.age || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Relationship:</strong>
              {data?.dependents?.relationship || "--"}
            </div>
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default PersonalInfo;
